export default function externalLinks() {
  Array.from(document.getElementsByTagName("a"))
    .filter((a) => a.host != document.location.host)
    .forEach((a) => (a.target = a.target || "_blank"));
}

export function startExternalLinks() {
  document.addEventListener("DOMContentLoaded", externalLinks);
}
